/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as PushConstants  from 'dashboard/Push/PushConstants.js';
import PropTypes           from 'prop-types';
import PushAudiencesOption from 'components/PushAudiencesSelector/PushAudiencesOption.react';
import React               from 'react';
import styles              from 'components/PushAudiencesSelector/PushAudiencesSelector.scss';
import { fromJS }          from 'immutable';

const AUDIENCE_SIZE_FETCHING_ENABLED = true;
const AUDIENCE_CREATED_DATE_ENABLED = true;

const PushAudiencesOptions = ({
  availableDevices,
  current,
  onChange,
  onEditAudience,
  schema,
  audiences,
}) => <div>
  {audiences.map(({
    icon,
    objectId,
    name,
    query,
    createdAt,
    filters,
  }) => {
    // filters = filters || new List()
    const queryOrFilters = objectId === PushConstants.NEW_SEGMENT_ID ?
    // const queryOrFilters = objectId !== 'everyone' ?
      filters.push(fromJS({
        field: 'deviceType',
        constraint: 'containedIn',
        array: query.deviceType['$in'],
      })) :
      query;

    return <PushAudiencesOption
      availableDevices={availableDevices}
      icon={icon}
      key={objectId}
      id={objectId}
      name={name}
      query={query}
      createdAt={new Date(createdAt)}
      isChecked={current === objectId ? true : false}
      //Super janky. Only works because open dashboard doesn't have saved audiences
      onChange={() => onChange(objectId, queryOrFilters)}
      onEditAudience={onEditAudience}
      schema={schema}
      filters={filters} />
  })}
</div>

let PushAudiencesSelector = ({
  currentApp,
  defaultAudience,
  newSegment,
  audiences,
  availableDevices,
  children,
  current,
  onChange,
  onEditAudience,
  schema,
}) => {

  // TODO: @pivanov - just fix this
  // let availableDevices = ['ios'];
  // currentApp.fetchAvailableDevices().then(({ _available_devices }) => {
  //   availableDevices = _available_devices;
  // });

  return (
    <div className={styles.container}>
      <div className={styles.body}>

        <PushAudiencesOptions
          availableDevices={availableDevices}
          current={current}
          onChange={onChange}
          onEditAudience={onEditAudience}
          schema={schema}
          audiences={defaultAudience ? [defaultAudience] : []} />
        <PushAudiencesOptions
          availableDevices={availableDevices}
          current={current}
          onChange={onChange}
          onEditAudience={onEditAudience}
          schema={schema}
          audiences={newSegment ? [newSegment] : []} />
        <PushAudiencesOptions
          availableDevices={availableDevices}
          current={current}
          onChange={onChange}
          onEditAudience={onEditAudience}
          schema={schema}
          audiences={audiences} />
      </div>
      <div className={styles.header}>
        <div className={[styles.cell, styles.col1].join(' ')}>
          Audience
        </div>
        {AUDIENCE_SIZE_FETCHING_ENABLED ? <div className={[styles.cell, styles.col2].join(' ')}>
          Size
        </div> : null}
        {AUDIENCE_CREATED_DATE_ENABLED ? <div className={[styles.cell, styles.col3].join(' ')}>
          Created
        </div> : null}

        <div className={[styles.cell, styles.col4].join(' ')}>
          Platforms
        </div>
        <div className={[styles.cell, styles.col5].join(' ')}></div>
      </div>
      {children}
    </div>
  );
}

PushAudiencesSelector.propTypes = {
  currentApp: PropTypes.object.isRequired,
  audiences: PropTypes.object.isRequired,
  defaultAudience: PropTypes.object,
  newSegment: PropTypes.object,
  current: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object,
  onEditAudience: PropTypes.func.isRequired,
};

export default PushAudiencesSelector;
